import { useState } from "react";
import NavBar from "../../components/layout/NavBar/NavBar";
import findmoreLogo from "../../assets/icons/findmore_simple_icon.svg";
import illustration from "../../assets/icons/people_illustration.svg";
import illustrationMobile from "../../assets/icons/man&woman.svg";
import styles from "./RequestAccess.module.css";
import { registrationRequest } from "../../services/registrationService";

export default function RequestAccess() {
    const [error, setError] = useState<string | null>(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const handleRequestAccess = async () => {
        setError(null);

        if(!name || !email) {
            setError("Por favor, preencha todos os campos.");
            return;
        }

        try {
            const response = await registrationRequest(name, email);
            if (response.success) {
                alert("Sucesso");
                setName("");
                setEmail("");
            } else {
                setError("Ocorreu um erro ao enviar o pedido");
            }
        } catch (err: any) {
            setError(err?.message || "Erro de server");
        }
    }

    return (
        <div className={styles.requestAccessContainer}>
            <div className={styles.navbarWrapper}>
                <NavBar items={[]} />
            </div>
            {/* Findmore logo para mobile */}
            <img src={findmoreLogo} alt="Logo" className={styles.mobileLogo} />

            <div className={styles.requestContent}>
                <div className={styles.requestBox}>
                    <h1 className={styles.requestTitle}>Avaliação 360º</h1>
                    <p className={styles.requestDescription}>
                        Um espaço para te autoavaliares, reconhecer o valor dos teus colegas e, se for o caso,
                        acompanhar o crescimento da tua equipa. A melhoria contínua começa contigo.
                    </p>
                    <input type="text" placeholder="Nome" className={styles.nameInput} value={name} onChange={(e) => setName(e.target.value)}/>
                    <input type="email" placeholder="Email" className={styles.emailInput} value={email} onChange={(e) => setEmail(e.target.value)}/>
                    {error && <p className={styles.errorMessage}>{error}</p>}
                    <button className={styles.askButton} onClick={handleRequestAccess}>
                        <span>PEDIR ACESSO</span>
                    </button>
                </div>
            </div>
            <img src={illustration} alt="Ilustração" className={styles.requestIllustration} />
            <img
                src={illustrationMobile}
                alt="Ilustração Mobile"
                className={styles.illustrationMobile}
            />
        </div>

    );

}